import React from "react";
import { useSelector } from "react-redux";
import { createPortal } from "react-dom";
import { AccessibilityPopup, AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import closeIcon from '../../../assests/icons/close.png'
import Tooltip from "../tooltip/Tooltip";
import classes from './BackdropPopup.module.css'

const BackdropPopup = ({ style, dropClass, dropClassClose, close, children, accessibilityDescription }) => {

    const { texts } = useSelector(state => state.translate);

    const handleClick = (e) => {
        e && e.stopPropagation()
        close && close()
    }

    return createPortal(
        <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={close}>
            <div className={classes.BackdropPopupContainer}>
                <div className={`${classes.BackdropPopup} ${dropClass}`} style={style}>
                    {close &&
                        <div className={classes.CloseWrapper}>
                            <Tooltip text={texts.close} showTooltip={false}>
                                <AccessibilityClickableDiv onClick={(e) => handleClick(e)} accessibilityDescription={texts.close} >
                                    <AccessibilityHiddenImg src={closeIcon} className={`${classes.Close} ${dropClassClose}`} />
                                </AccessibilityClickableDiv>
                            </Tooltip>
                        </div>}
                    {children}
                </div>

            </div>
        </AccessibilityPopup>

        , document.body)
}

export default BackdropPopup;